const initialState = {
    procedimientos: [],
};

const facturaredux = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PROCEDIMIENTOS_FACTURA':
            return {
                ...state,
                procedimientos: [...state.procedimientos, ...action.payload ]
            }
        case 'DELETE_PROCEDIMIENTO_FACTURA' :
            return {
                ...state,
                procedimientos: state.procedimientos.filter(factura => factura.idprocedimiento_cita_paciente !== action.payload)
            } 
        case 'RESET_PROCEDIMIENTO_FACTURA' : 
            return {
                ...state,
                procedimientos: []
            }  
        case 'UPDATE_PROCEDIMIENTO_FACTURA' : {
            // COBERTURAS-SEGURO100-RUNTIME-FLOW-AUDIT-05: emparejar por
            // idprocedimiento_cita_paciente (PK unica de la linea), NO por
            // idExamenTipo. Con idExamenTipo, dos prestaciones pendientes del
            // MISMO examen (p.ej. 2x MEDICINA GENERAL, o Eco Pelvica + Eco
            // Testicular con el mismo tipo) colapsaban: `find` devolvia siempre
            // la primera, la 2a linea heredaba el idprocedimiento_cita_paciente
            // de la 1a y una prestacion desaparecia del detalle enviado a
            // /billing -> "aplique plan y no se creo la responsabilidad".
            const nuevos = action.payload;

            const actualizados = state.procedimientos.map(proc => {
                const actualizado = nuevos.find(
                    p => p.idprocedimiento_cita_paciente === proc.idprocedimiento_cita_paciente
                );
                return actualizado ? { ...proc, ...actualizado } : proc;
            });

            const nuevosNoExistentes = nuevos.filter(p =>
                !state.procedimientos.some(
                    proc => proc.idprocedimiento_cita_paciente === p.idprocedimiento_cita_paciente
                )
            );

            return {
                ...state,
                procedimientos: [...actualizados, ...nuevosNoExistentes]
            };
        }
        case 'UPDATE_CANTIDAD_PROCEDIMIENTO':
            return {
                ...state,
                procedimientos: state.procedimientos.map(p =>
                    p.idprocedimiento_cita_paciente === action.payload.id
                    ? { ...p, cantidad: action.payload.cantidad }
                       : p
                    )
                };
            

        default:
            return state;
    }

}

export default facturaredux;